import { injectable } from 'inversify'
import * as DTO from '@rw1/auto-generated-clients/generated/geolocation/dto.generated'
import * as Models from '@rw1/models'
import { ILocationMapper } from './ILocationMapper'
@injectable()
export class LocationMapper implements ILocationMapper {
    toModel(dto: DTO.Location): Models.Location {
        return {
            ipAddress: dto.ipAddress,
            city: dto.city,
            country: dto.country,
            countryCode: dto.countryCode,
            latitude: dto.latitude,
            longitude: dto.longitude,
            continent: dto.continent,
            continentCode: dto.continentCode,
            regionName: dto.regionName,
            regionPrefix: dto.regionPrefix,
        }
    }
}